import { Component, Input } from '@angular/core';
import { Discount } from '@shared/models/discount';

@Component({
  selector: 'app-discount-value-type',
  templateUrl: './discount-value-type.component.html',
  styleUrls: ['./discount-value-type.component.scss'],
  standalone: false,
})
export class DiscountValueTypeComponent {
  @Input() discount: Discount;
}
